import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../lib/config';
import { useAuth } from '../context/AuthContext';

export default function VerifyPage() {
  const [message, setMessage] = useState('メール確認中...');
  const navigate = useNavigate();
  const { login, getDashboardUrl } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setMessage('トークンが見つかりません');
      return;
    }
    const url = `${API_BASE}/auth/verify-email?token=${encodeURIComponent(token)}`;
    fetch(url)
      .then(async (r) => {
        if (!r.ok) {
          const text = await r.text().catch(() => '');
          throw new Error(text || 'verify failed');
        }
        return r.json();
      })
      .then(async (data) => {
        // 認証完了後、自動ログインを試行
        try {
          const email = localStorage.getItem('pending_email');
          const password = localStorage.getItem('pending_password');
          const userType = localStorage.getItem('pending_user_type');

          if (email && password) {
            setMessage('認証が完了しました。自動ログイン中...');
            const result = await login(email, password);
            // 一時情報は消しておく
            try {
              localStorage.removeItem('pending_email');
              localStorage.removeItem('pending_password');
              localStorage.removeItem('pending_user_type');
            } catch (e) {}

            if (result?.success && result?.user) {
              const utype = result.user.user_type || userType || 'job_seeker';
              const nextUrl = getDashboardUrl(utype);
              setMessage('ログインに成功しました。ダッシュボードへ移動します...');
              setTimeout(() => {
                navigate(nextUrl, { replace: true });
              }, 500);
              return;
            }
          }

          // pending 資格情報がない場合は、verify応答の user_id で開発用ログインを試行
          if ((!email || !password) && data?.user_id) {
            const resp = await fetch(`${API_BASE}/auth/dev-login-by-email?email=${encodeURIComponent(data.user_id)}`, {
              method: 'POST'
            });
            if (resp.ok) {
              const d = await resp.json();
              try {
                localStorage.setItem('token', d.access_token);
                localStorage.setItem('user', JSON.stringify(d.user));
              } catch (e) {}
              const nextUrl = getDashboardUrl(d.user.user_type || 'job_seeker');
              setMessage('ログインに成功しました。ダッシュボードへ移動します...');
              setTimeout(() => navigate(nextUrl, { replace: true }), 400);
              return;
            }
          }
        } catch (e) {
          console.error('Auto login after verify failed:', e);
        }
        // フォールバック: ログイン画面へ
        setMessage('認証が完了しました。ログイン画面へ移動します。');
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 800);
      })
      .catch((err) => {
        console.error('Verify error:', err);
        setMessage('認証に失敗しました。リンクが無効か期限切れの可能性があります。');
      });
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center p-6">
      <h1 className="text-xl font-semibold text-gray-800">{message}</h1>
    </main>
  );
}
